import React, { useEffect } from 'react';
import Bredcom from '../../Bredcom/Main';
import Header from '../../headerone/Main';
import Blog from '../../menhome/Blog';
import Event from '../../menhome/Event';
import Newlast from '../../menhome/Newlast';
import Opcommand from '../menoperationcommand/Opcommand';



function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Operation Command";
  }, [])

  return (
    <>
         <Header/>

         <div className="page-wrapper">
          <Bredcom 
            subtitle="Home"
            title="operation command"
            subtitledown="Operation Command"
           />
            <Opcommand/>
            <Event/>
            <Blog/>
            <Newlast/>
         </div>
    </>
  )
}

export default Main